import { Observable } from 'rxjs'
import { $waitForElements as $waitForEls } from '../../../NonReact/common/RxJS/WaitForElements'

export const $waitForElements = (selector: string): Observable<HTMLElement[]> =>
    $waitForEls(selector, '.tour-overlay', '.MuiPopover-root', '.isolator')
